var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var convertToClientAccountData = function (data) {
    var _a, _b;
    return (__assign(__assign({}, data), { phoneNumbers: !!((_a = data.additionalPhoneNumbers) === null || _a === void 0 ? void 0 : _a.length)
            ? (_b = data.additionalPhoneNumbers) === null || _b === void 0 ? void 0 : _b.map(function (ph) { return ({
                number: ph.phoneNumber.replaceAll(' ', ''),
                id: ph.id,
            }); })
            : [], mainPhoneNumber: data.phoneNumber.replaceAll(' ', ''), compannyInfo: data.companyDescription, companyLogo: data.logoUrl, companyName: data.companyName, companyAddress: data.companyAddress, directorFullName: data.directorFullName, payersRegistrationNumber: data.payersRegistrationNumber, paymentAccount: data.paymentAccount, bankAddress: data.bankAddress, bankIdNumber: data.bankIdNumber }));
};
